import request from '@/network/request.js';
import urls from '@/network/api.js';

export default {
  namespaced: true,
  state: () => ({
    info: JSON.parse(localStorage.getItem('USER_INFOS')) || {
      id: null,
      userName: '',
      email: '',
      mobile: '',
      status: 0,
      wxNo: '',
      wxTime: '',
      wxUnionid: '',
      createTime: '',
    },
    cartCount: 0,
  }),
  mutations: {
    SET_INFO(state, info) {
      state.info = info;
      localStorage.setItem('USER_INFOS', JSON.stringify(info));
    },
    SET_CART_COUNT(state, count) {
      state.cartCount = count;
    },
  },
  actions: {
    async fetchInfo({ commit }) {
      const token = localStorage.getItem('token');
      const mobile = localStorage.getItem('mobile');

      if (token && mobile) {
        try {
          //const res = await this.$request(this.$urls.m().userInfo + mobile).modeget();
          //const res = await new request(urls.m().userInfo + mobile).modeget()
          const req = new request(urls.m().userInfo + mobile);
          const res = await req.modeget();
          if (res.data.success) {
            commit('SET_INFO', res.data.data);
          }
        } catch (error) {
          console.error('Failed to fetch user info:', error);
          const status = error?.status || error?.response?.status
          if(status === 401 || status === '401'){
            //console.log('登录问题')
            localStorage.removeItem('token')
            localStorage.removeItem('mobile')
            localStorage.removeItem('USER_INFOS')
            localStorage.removeItem('redirectUrl')
          }
        }
      }
    },
    async fetchCartCount({ commit }, memberId) {
      try {
       // const res = await this.$request(this.$urls.m().getCartCount + '?memberId=' + memberId).modeget();
        //const res = await new request(urls.m().getCartCount + '?memberId=' + memberId).modeget()
        const req = new request(urls.m().getCartCount + '?memberId=' + memberId);
          const res = await req.modeget();
        if (res.data.success) {
          commit('SET_CART_COUNT', res.data.data);
        }
      } catch (error) {
        console.error('Failed to fetch cart count:', error);
      }
    },
    async updateCartCount({ commit }, count) {
      commit('SET_CART_COUNT', count);
    },
  },
  getters: {
    getInfo: (state) => state.info,
    getCartCount: (state) => state.cartCount,
  },
};